import {invalidValidationResult, ValidationResult} from "../../../util/validation/validation-result"

export const validatePositiveNumber = (numberToValidate: number | undefined): ValidationResult => {
  if (numberToValidate === undefined) return invalidValidationResult("Dit is een verplicht veld")
  if (numberToValidate < 0) return invalidValidationResult("Vul minimaal 0 in")
  return {valid: true}
}
export const validatePositiveNumberMax = (numberToValidate: number | undefined, maxNumber: number): ValidationResult => {
  if (numberToValidate === undefined) return invalidValidationResult("Dit is een verplicht veld")
  if (numberToValidate < 0) return invalidValidationResult("Vul minimaal 0 in")
  if (numberToValidate > maxNumber) return invalidValidationResult(`Vul maximaal ${maxNumber} in`)
  return {valid: true}
}